import { useQuery } from '@apollo/react-hooks';
import {
  GET_LEARNING_HUB_TOPICS,
  GET_LEARNING_HUB_VIDEOS,
  GET_LEARNING_HUB_SETTINGS,
} from './queries';

// Transform API video to frontend shape
const transformVideo = (v) => ({
  id: String(v.id),
  title: v.title,
  description: v.description,
  duration: v.duration_label,
  vimeoId: v.vimeo_id,
  topic: v.topic?.slug || '',
  topicName: v.topic?.name || '',
  mode: v.mode,
  isNew: v.is_new,
  isFeatured: v.is_featured,
  helpLink: v.help_link,
});

// Transform API topic to frontend shape
const transformTopic = (t) => ({
  id: t.slug,
  name: t.name,
  slug: t.slug,
  description: t.description,
  icon: t.icon,
  mode: t.mode,
  sort_order: t.sort_order,
});

export function useGetLearningHubTopics(mode) {
  const result = useQuery(GET_LEARNING_HUB_TOPICS, {
    variables: { mode },
  });

  const topics = result.data?.getLearningHubTopics?.map(transformTopic) || [];

  return { ...result, topics };
}

export function useGetLearningHubVideos(input) {
  const result = useQuery(GET_LEARNING_HUB_VIDEOS, {
    variables: { input },
  });

  const videos =
    result.data?.getLearningHubVideos?.results?.map(transformVideo) || [];
  const count = result.data?.getLearningHubVideos?.count || 0;

  return { ...result, videos, count };
}

export function useGetLearningHubSettings() {
  const result = useQuery(GET_LEARNING_HUB_SETTINGS);

  const settings = result.data?.getLearningHubSettings || null;

  return { ...result, settings };
}
